module.exports = __webpack_public_path__ + "static/img/tip.d56a603.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoDetail/tip.svg
// module id = Rc8E
// module chunks = 66